import React from 'react';

interface State { hasError: boolean; err?: Error; }

/** Evita la pantalla en blanco: si algo revienta al renderizar (ej. un chunk
 *  que no cargó estando offline), muestra un aviso con botón de reintentar
 *  en vez de dejar el árbol de React desmontado. */
class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(err: Error): State {
    return { hasError: true, err };
  }

  componentDidCatch(err: Error) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', err);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const offline = typeof navigator !== 'undefined' && !navigator.onLine;
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: 24, textAlign: 'center', background: '#f8fafc', color: '#1e293b' }}>
        <div style={{ fontSize: 40 }}>{offline ? '📴' : '⚠️'}</div>
        <div style={{ fontSize: 18, fontWeight: 700 }}>{offline ? 'Sin conexión' : 'Algo salió mal'}</div>
        <div style={{ fontSize: 14, color: '#64748b', maxWidth: 340 }}>
          {offline
            ? 'No se pudo cargar esta parte de la app sin internet. Cuando vuelva la conexión, recarga.'
            : 'Ocurrió un error al mostrar la página. Intenta recargar.'}
        </div>
        <button
          onClick={() => window.location.reload()}
          style={{ marginTop: 4, background: '#2563eb', color: '#fff', border: 'none', borderRadius: 10, padding: '10px 20px', fontWeight: 700, fontSize: 15, cursor: 'pointer' }}
        >
          Recargar
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
